import { useEffect, useState } from 'react'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { CC_PRODUCT_ID, TOKEN_2 } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import { getTranslated  } from "../../utils/CommonUtils"
import { sendGTMEvent } from '../../utils/GTMUtils'
import { useSelector } from "react-redux"
import { Divider, Tag } from 'antd'
import { DARK_GRAY } from "../../styles/styleUtils"
import UMCButton from '../common/UMCButton'
import UMCTable from "../common/UMCTable"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import TabExtraContent from '../common/TabExtraContent'
import CustomDialog from './CustomDialog'
import parse from 'html-react-parser'
import { Button } from 'antd'
import { OXE_DISCONNECTION } from "../../utils/Constants"
import store from "../../store/store"
import { handleOXEDisconnection } from "../../store/actions/OxeActions"

//==============
// Summary page
//==============
const SummaryPage = ({onNext, activeProfile, sipTrunkConfig, prerequisites, onFinish}) => { 
    const [summary, setSummary] = useState([]);
    const [items, setItems] = useState([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dlgType, setDlgType] = useState();
    const [title, setTitle] = useState();
    const [message, setMessage] = useState([]);

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);

    // Configuration has failed
    const [successConfig, setSuccessConfig] = useState(false);

    // Values that are considered as OK
    const conditions = ["200", "201", "202", "204", "205", "206"];
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);

    // GTM status enumeration
    const GtmStatus = {
        SUCCESS: "Success",
        FAILURE: "Failure"
    }

    // GTM event for success and failure
    //
    /**
     * @param {string} ccproductid
     * @param {object} activeProfile
     * @param {GtmStatus} status
     */
    const sipCreactionEndEvent = (ccproductid, activeProfile, status) => {
        sendGTMEvent({
            event: "umc_SIP_trunk_creation_completed",
            status: status,
            sip_profile: activeProfile.name,
            cc_product_id: ccproductid
        });
    }

    // Adjust the trunk list to be understandable
    function conformObj(obj) {
        switch (obj['operation']) {
            case "GET":
                obj['operation'] = getTranslated(dict, "LABEL_READ");
                break;
            case "POST":
                obj['operation'] = getTranslated(dict, "LABEL_CREATE");
                break;
            case "PUT":
                obj['operation'] = getTranslated(dict, "LABEL_UPDATE");
                break;
                
            default:
                break;
        }

        if (obj['status'].charAt(0) === 'H') {
            obj['status'] = obj['status'].substring(9);
        }
/*        if (obj.error !== null)
            obj['error'] = obj.error.message + ": " + obj.error.details.message;*/

        return obj;
    }

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_SIP_TRUNK") + " : " + activeProfile.name));
    }, [dict]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    useEffect(() => {
        var ccproductid = getSessionItem(CC_PRODUCT_ID);
        var nodeNumber = oxeAndClientInfo?.nodeNumber || "";

        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));

        const sendData = async () => {
            var url, headerSection;

            try {
                url = SIP_URL + "/siptrunk/" + nodeNumber + "/" + ccproductid + "/" + activeProfile.id;
                headerSection = { 
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${getSessionItem(TOKEN_2)}`,
                };
                dispatch(setContentLoading(true));
                const response = await fetch(url, {
                    method: "POST",
                    headers: headerSection,
                    body: JSON.stringify(sipTrunkConfig),
                });
                dispatch(setContentLoading(false));

                if (response.ok) {
                    let list = await response.json();
                    if (list.data) {
                        setItems(list.data);
                        
                        // Determine if all operations were successful
                        const isSuccess = list.data.every(item => conditions.some(val => item.status.includes(val)));
                        sipCreactionEndEvent(ccproductid, activeProfile, isSuccess? GtmStatus.SUCCESS : GtmStatus.FAILURE);
                        
                        // Set the state to determine if the end message has to be displayed
                        setSuccessConfig(isSuccess);
                    }
                    else {
                        sipCreactionEndEvent(ccproductid, activeProfile, GtmStatus.FAILURE);
                        displayError(list.code, list.message, list.error)
                    }
                } else {
                    sipCreactionEndEvent(ccproductid, activeProfile, GtmStatus.FAILURE);
                    if (response.status === 401) {
                        const data = await response.json()
                        if (data.errorCode === OXE_DISCONNECTION) {
                            store.dispatch(handleOXEDisconnection());
                        }
                        else
                            window.location = "/logout"
                    }
                }
            }
            catch(e) {
                console.error(e);
                sipCreactionEndEvent(ccproductid, activeProfile, GtmStatus.FAILURE);
                dispatch(setContentLoading(false));
            }
        };
        if (sipTrunkConfig?.Profile) {
            sendData();
            //console.log("Sent !", sipTrunkConfig);
        }
        else {
            console.log("Not sent !", sipTrunkConfig);
        }
    }, []);
    
    useEffect(() => {
        setSummary(items.map(obj => conformObj(obj)));
    }, [items]);

    // Display Error
    const displayError = (code, message, error) => {
        setDlgType("Error");
        setTitle("Error"); 
        setMessage(code + " " + message + " (" + error + ")");
        showModal();
    }

    // Columns definition
    const statusColumns = [
        {
            title: getTranslated(dict, "LABEL_OBJECT_UPPER"),
            dataIndex: 'object',
            key: 'object',
        },
        {
            title: getTranslated(dict, "LABEL_OPERATION_UPPER"),
            dataIndex: 'operation',
            key: 'operation',
        },
        {
            title: getTranslated(dict, "LABEL_INDEX_UPPER"),
            dataIndex: 'index',
            key: 'index',
        },
        {
            title: getTranslated(dict, "LABEL_VALUE_UPPER"),
            dataIndex: 'value',
            key: 'value',
        },
        {
            title: getTranslated(dict, "LABEL_STATUS_UPPER"),
            key: 'status',
            dataIndex: 'status',
            render: (status) => (
                // Set the color of the result of the operation
                <Tag color={conditions.some(val => status.includes(val)) ? 'green' : 'red'} key={status}>
                    {status}
                </Tag> 
            ),
        },
        {
            title: getTranslated(dict, "LABEL_ERROR_UPPER"),
            dataIndex: 'error',
            key: 'error',
            render: (error) => {
                if (!error?.message) {
                    return null; // Don't render anything if message is empty or undefined
                }
                return (
                    <div>
                        {error?.code} {error?.message}
                        {error?.details && (
                            <ul>
                            {error?.details.map((msg, index) => (
                                <li key={index}>{msg.message}</li>
                            ))}
                            </ul>
                        )}
                    </div>
                );
            }
        },
    ];

    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={["help"]}
            documentButtonText={activeProfile.docRef}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-trunk__SIP-status`, "_blank")
           }}
        />
    }

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleClose = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        onFinish();
    };

    // Display the message what to do next for public
    const endMessagePublic = () => {
        var msg = "", tcrelatedmsg = "", cnt = 0;

        //==== Fixed part of messages
        msg = "<ul><li>" + getTranslated(dict, "MSG_DDI_TRANSLATOR") + "<br/><small style='color: #5050F0; padding-left:20px;'>Translator&nbsp;>&nbsp;External&nbsp;Numbering&nbsp;Plan&nbsp;>&nbsp;DID&nbsp;numbering&nbsp;translator: LIMITED_LOCAL_DID</small></li>";
        msg += "<li>" + getTranslated(dict, "MSG_EXT_CALLBACK_TABLE") + "<br/><small style='color: #5050F0; padding-left:20px;'>Translator&nbsp;>&nbsp;External&nbsp;Numbering&nbsp;Plan&nbsp;> Ext.Callback&nbsp;Translation&nbsp;Tables</small></li>";
        msg += "<li>" + getTranslated(dict, "MSG_DISCRIMINATOR_CONTENT") + "</li></ul>";
        //==== Variable part of messages related to TC configuration
        // Title with TC ref
        tcrelatedmsg = "<p style='padding-left:20px; text-decoration:underline'>According to " + activeProfile.docRef + ":</p><ul>"
        // Messages related to what has been created
        summary.forEach(topic => {
            if ((topic.object === "External Signalling Parameters") && (topic.index === "NPD For External Forward")) { // NPD for external forward
                msg += "<li>" + getTranslated(dict, "MSG_NPD_FOR_EXT_FORWARD") + "<br/><small style='color: #5050F0; padding-left:20px;'>System&nbsp;>&nbsp;Other&nbsp;System&nbsp;Param.&nbsp;>&nbsp;External&nbsp;Signaling&nbsp;Parameters:&nbsp;NPD&nbsp;for&nbsp;external&nbsp;forward</small></li>";
            }
            if (topic.object === "SIP Parameters") {
                switch (topic.index) {
                    case "Loose Route with RegID": // Loose route with regid
                        tcrelatedmsg += "<li>" + getTranslated(dict, "MSG_LOOSE_ROUTE_WITH_REGID") + "<br/><small style='color: #5050F0; padding-left:20px;'>System&nbsp;>&nbsp;Other&nbsp;System&nbsp;Param.&nbsp;>&nbsp;SIP&nbsp;parameters:&nbsp;Loose&nbsp;route&nbsp;with&nbsp;regid</small></li>";
                        cnt++;                        
                        break;
                    case "Via Header Inbound Calls Routing": // Via header
                        tcrelatedmsg += "<li>" + getTranslated(dict, "MSG_VIA_HEADER") + "<br/><small style='color: #5050F0; padding-left:20px;'>System&nbsp;>&nbsp;Other&nbsp;System&nbsp;Param.&nbsp;>&nbsp;SIP&nbsp;parameters:&nbsp;Via&nbsp;Header&nbsp;Inbound&nbsp;Calls&nbsp;Routing</small></li>";
                        cnt++;
                        break;
                    default:
                        break;
                }
            }
        });
        // When 'TCP when long message' is different from OXE configuration (and is not null), then display a message 
        prerequisites.forEach(preReq => { 
            if (preReq.parameter === "SIP_MOVE_TO_TCP") { // TCP when long message
                if ((activeProfile.sipMoveToTcp !== null) && (activeProfile.sipMoveToTcp !== preReq.isExisting)) {
                    tcrelatedmsg += "<li>" + getTranslated(dict, "MSG_TCP_WHEN_LONG_MSG") + "<br/><small style='color: #5050F0; padding-left:20px;'>SIP&nbsp;>&nbsp;SIP&nbsp;Proxy:&nbsp;TCP&nbsp;when&nbsp;long&nbsp;message</small></li>";
                    cnt++;
                }
            }
        });
        tcrelatedmsg += "</ul>";
        if (cnt > 0) // Display the variable part of messages (cnt counts the number of messages, used for the group title)
            msg += tcrelatedmsg;
        // Reboot message
        msg += "<p style='color: #FF6565; padding-left:20px;'>"+ getTranslated(dict, "MSG_OXE_REBOOT") + "</p>";
        setMessage(parse(msg));
        showModal();
    }

    // Display the message what to do next for VAA
    const endMessageVAA = () => {
        var msg = "";

        // Reboot message
        msg += "<p style='color: #FF6565; padding-left:20px;'>" + getTranslated(dict, "MSG_OXE_REBOOT") + "</p>";
        setMessage(parse(msg));
        showModal();
    }

    // Display the message what to do next for VNA
    const endMessageVNA = () => {
        var msg = "";

        // Reboot message
        msg += "<p style='color: #FF6565; padding-left:20px;'>" + getTranslated(dict, "MSG_OXE_REBOOT") + "</p>";
        setMessage(parse(msg));
        showModal();
    }

    // Display the message what to do next for WebRTC
    const endMessageWebRTC = () => {
        var msg = "", found = false;
        const keywords = ["200", "201"];

        // If the prefix has been created, indicate that the PBX has to rebooted
        summary.forEach(topic => {
            if (topic.object === "Prefix Plan") {
                found = keywords.some(keyword => topic.status.includes(keyword));
            }
            else {
                if (topic.object === "Ext.Callback Translation Tables") {
                    if (!topic.value.includes("Country Codes"))
                        msg += "<ul><li>" + getTranslated(dict, "MSG_COUNTRY_CODE_NOT_SET") + "<br/><small style='color: #5050F0; padding-left:20px;'>Translator&nbsp;>&nbsp;External&nbsp;Numbering&nbsp;Plan&nbsp;>&nbsp;Ext.Callback&nbsp;Translation&nbsp;Tables</small></li></ul>";
                }
            }
        });

        if (found === true) {
            // Reboot message
            msg += "<p style='color: #FF6565; padding-left:20px;'>"+ getTranslated(dict, "MSG_OXE_REBOOT") + "</p>";
            setMessage(parse(msg));
            showModal();
        }
        else {
            onFinish();
        }
    }

    // Display the message what to do next for Dispatch Console
    const endMessageDC = () => {
        var msg = "";

        summary.forEach(topic => {
            if ((topic.object === "CSTA") && (topic.status.includes("200"))) {
                msg += "<ul>";
                if (topic.value.includes("Automatic Reconnection")) {
                    msg += "<li>" + getTranslated(dict, "MSG_CSTA_AUTOMATIC_RECONNECTION") + "<br/><small style='color: #5050F0; padding-left:20px;'>Application&nbsp;>&nbsp;CSTA</small></li>";
                }
                if (topic.value.includes("Call Line Identification")) {
                    msg += "<li>" + getTranslated(dict, "MSG_CSTA_CLI") + "<br/><small style='color: #5050F0; padding-left:20px;'>Application&nbsp;>&nbsp;CSTA</small></li>";
                }
                msg += "</ul>";
            }
        });
        // Reboot message
        msg += "<p style='color: #FF6565; padding-left:20px;'>" + getTranslated(dict, "MSG_OXE_REBOOT") + "</p>";
        setMessage(parse(msg));
        showModal();
    }


    // function to select the display of the end popup
    const endMessage = () => {
        if (successConfig === true) {
            setTitle("");
            setDlgType("Bubble");
            switch (activeProfile.type) {
                case "public":
                    endMessagePublic();
                    break;
                case "Visual AA":
                    endMessageVAA();
                    break;
                case "Visual NA":
                    endMessageVNA();
                    break;
                case "WebRTC":
                    endMessageWebRTC();
                    break;
                case "Dispatch":
                    endMessageDC();
                    break;
                default: break;
            }
        }
        else {
            onFinish();
        }
    }

    return (<>
        <div className="profile-span">
            <div>
                <Divider orientation="left" orientationMargin="0" plain style={{borderColor: DARK_GRAY, padding: "0 0 10px 0"}}>
                    {getTranslated(dict, "LABEL_CONFIG_STATUS")}
                </Divider>
                <UMCTable dataSource={summary} columns={statusColumns} size="small" loading={!items?.length} handleRowHover={()=>{}} className='table-striped-rows' />
            </div>
        </div>
        <div className="profile-span sip-nav-buttons">
            <UMCButton
                    className="sip-navigation-button sip-btn-fontsize"
                    label={getTranslated(dict, "LABEL_FINISH")}
                    type="primary"
                    onClick={endMessage} />
        </div>
        <CustomDialog
            title={title}
            open={isModalOpen}
            width={dlgType === "Error" ? "400px" : "750px"}
            type={dlgType} 
            footer={<Button key="cancel" type="primary" onClick={handleCancel} className="sip-modal-btn" >
                        {getTranslated(dict, "LABEL_CLOSE")} 
                    </Button>}
            onCancel={handleClose}
            >
            {message}
        </CustomDialog>
    </>);
}

export default SummaryPage;
